import { render, staticRenderFns } from "./EditDriverModal.vue?vue&type=template&id=56e0ac36&scoped=true&"
import script from "./EditDriverModal.vue?vue&type=script&lang=js&"
export * from "./EditDriverModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0ac36",
  null
  
)

export default component.exports